import React, { useEffect } from 'react';
import './styles.scss';
import i18next from 'i18next';
import { triggerConfetti } from './confetti';
import { Trans } from 'react-i18next';
import { introDone } from '../../../App';

interface CountdownProps {
    days: number;
}

export default function Countdown({ days }: CountdownProps): JSX.Element {
    useEffect(() => {
        const handleIntroDone = () => {
            if (days === 0) setTimeout(()=> triggerConfetti(), 250);
        };

        window.addEventListener('introDone', handleIntroDone);
        if (introDone && days === 0) {
            setTimeout(() => triggerConfetti(), 250);
        }

        return () => window.removeEventListener('introDone', handleIntroDone);
    }, [days]);

    return days > 0 ? (
        <>
            <figure className='countdown'>
                <figcaption>
                    <time dateTime={`P${days}D`}>
                        {days > 1 ? (
                            <Trans i18nKey='DaysLeftMulti' values={{ days }} components={{ strong: <strong /> }} />
                        ) : (
                            <Trans i18nKey='DaysLeftSingle' components={{ strong: <strong /> }} />
                        )}
                    </time>
                </figcaption>
            </figure>
            <p className='description large'>{i18next.t('CountdownParagraph')}</p>
        </>
    ) : (
        <div className='outer-circle'>
            <button id='confetti' className='circle-badge' onClick={() => triggerConfetti()}>
                <svg focusable='false'>
                    <use xlinkHref='#car-bow'></use>
                </svg>
                <span>{i18next.t('TodayBtn').toUpperCase()}</span>
            </button>
        </div>
    );
}
